<template>
  <div id="detail-data" class="container">
    <div class="mt-3">詳細データ</div>
    <div class="mt-3 text-center set">{{ game.gameInfo.matchName }}</div>
    <div class="row">
      <div class="col-md-6">
        <DetailDataCard :title="'得点数'"
          :player1Name="this.game.gameInfo.player1Name"
          :player2Name="this.game.gameInfo.player2Name"
          :data="getPointCnt"/>
      </div>
      <div class="col-md-6">
        <DetailDataCard
          :title="'サーブ時得点数'"
          :player1Name="this.game.gameInfo.player1Name"
          :player2Name="this.game.gameInfo.player2Name"
          :data="getPointCntAtServeAndReceive.serve"/>
      </div>
      <div class="col-md-6">
        <DetailDataCard
          :title="'レシーブ時得点数'"
          :player1Name="this.game.gameInfo.player1Name"
          :player2Name="this.game.gameInfo.player2Name"
          :data="getPointCntAtServeAndReceive.recieve"/>
      </div>
      <div class="col-md-6">
        <DetailDataCard
          :title="'得点時平均打球回数'"
          :player1Name="this.game.gameInfo.player1Name"
          :player2Name="this.game.gameInfo.player2Name"
          :data="getRallyCntAveAndMax.ave"/>
      </div>
      <div class="col-12">
        <DetailDataCardRallyCnt :title="'得点時打球回数'"
          :playerName="this.game.gameInfo.player1Name" :data="getRallyCnt.player1"/>
      </div>
      <div class="col-12">
        <DetailDataCardRallyCnt :title="'得点時打球回数'"
          :playerName="this.game.gameInfo.player2Name" :data="getRallyCnt.player2"/>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12 text-center">
        <b-button variant="outline-secondary" class="btn">
          <div class="text-dark" @click="$router.go(-1);">データページへ戻る</div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DetailDataCard from '@/components/molecules/DetailDataCard';
import DetailDataCardRallyCnt from '@/components/molecules/DetailDataCardRallyCnt';
import func from '@/lib/func';

export default {
  name: 'detail-data',
  components: {
    DetailDataCard,
    DetailDataCardRallyCnt,
  },
  computed: {
    splitData() {
      const splitSetData = [];
      for (let i = 0; i < 9; i++) {
        splitSetData.push(func.sliceData(i, this.game));
      }
      // console.log(splitSetData)
      return splitSetData;
    },
    getPointCnt() {
      // 得点数を計算する
      const ret = [];
      Object.keys(this.splitData).forEach((key) => {
        const column = [0, 0];
        for (let j = 0; j < this.splitData[key].points.length; j++) {
          if (this.splitData[key].points[j] === 1) {
            column[0] += 1;
          } else {
            column[1] += 1;
          }
        }
        const total = column[0] + column[1];
        column[0] = `${column[0]} / ${total}`;
        column[1] = `${column[1]} / ${total}`;
        if (this.splitData[key].points.length > 0) {
          ret.push(column);
        }
      });
      return ret;
    },
    getPointCntAtServeAndReceive() {
      const ret = { serve: [], recieve: [] };
      Object.keys(this.splitData).forEach((key) => {
        const columnAtServe = [0, 0];
        const columnAtRevieve = [0, 0];
        let info = {
          p1: 0,
          p2: 0,
          s1: 0,
          s2: 0,
        };
        const FirstGameServe = [];
        const FirstGameReceive = [];
        for (let j = 0; j < this.splitData[key].points.length; j++) {
          // サーバーの判定
          if (func.svJudge(info)) {
            FirstGameServe.push(this.splitData[key].points[j]);
          } else {
            FirstGameReceive.push(this.splitData[key].points[j]);
          }
          // 次ポイントへ
          info = func.nextPoint(info, this.splitData[key].points[j]);
        }
        if (key === '0' || key % 2 === 1) {
          if (this.game.gameInfo.firstGameServer === 1) {
            columnAtServe[0] = `${func.sumArr(FirstGameServe)} / ${FirstGameServe.length}`;
            columnAtRevieve[1] = `${(FirstGameServe.length - func.sumArr(FirstGameServe))} / ${FirstGameServe.length}`;
            columnAtServe[1] = `${(FirstGameReceive.length - func.sumArr(FirstGameReceive))} / ${FirstGameReceive.length}`;
            columnAtRevieve[0] = `${(func.sumArr(FirstGameReceive))} / ${FirstGameReceive.length}`;
          } else if (this.game.gameInfo.firstGameServer === 2) {
            columnAtServe[1] = `${(FirstGameServe.length - func.sumArr(FirstGameServe))} / ${FirstGameServe.length}`;
            columnAtRevieve[0] = `${(func.sumArr(FirstGameServe))} / ${FirstGameServe.length}`;
            columnAtServe[0] = `${func.sumArr(FirstGameReceive)} / ${FirstGameReceive.length}`;
            columnAtRevieve[1] = `${(FirstGameReceive.length - func.sumArr(FirstGameReceive))} / ${FirstGameReceive.length}`;
          }
        } else {
          if (this.game.gameInfo.firstGameServer === 2) {
            columnAtServe[0] = `${func.sumArr(FirstGameServe)} / ${FirstGameServe.length}`;
            columnAtRevieve[1] = `${(FirstGameServe.length - func.sumArr(FirstGameServe))} / ${FirstGameServe.length}`;
            columnAtServe[1] = `${(FirstGameReceive.length - func.sumArr(FirstGameReceive))} / ${FirstGameReceive.length}`;
            columnAtRevieve[0] = `${(func.sumArr(FirstGameReceive))} / ${FirstGameReceive.length}`;
          } else if (this.game.gameInfo.firstGameServer === 1) {
            columnAtServe[1] = `${(FirstGameServe.length - func.sumArr(FirstGameServe))} / ${FirstGameServe.length}`;
            columnAtRevieve[0] = `${(func.sumArr(FirstGameServe))} / ${FirstGameServe.length}`;
            columnAtServe[0] = `${func.sumArr(FirstGameReceive)} / ${FirstGameReceive.length}`;
            columnAtRevieve[1] = `${(FirstGameReceive.length - func.sumArr(FirstGameReceive))} / ${FirstGameReceive.length}`;
          }
        }
        if (FirstGameServe.length > 0 || FirstGameReceive.length > 0) {
          ret.serve.push(columnAtServe);
          ret.recieve.push(columnAtRevieve);
        }
      });
      return ret;
    },
    getRallyCntAveAndMax() {
      const ret = { max: [], ave: [] };
      Object.keys(this.splitData).forEach((key) => {
        const columnAtAve = [0, 0];
        const dat = { pla1max: 0, pla2max: 0, pla1labels: [], pla2labels: [] };
        for (let j = 0; j < this.splitData[key].points.length; j++) {
          if (this.splitData[key].points[j] === 1) {
            dat.pla1labels.push(this.splitData[key].labels[j]);
            dat.pla1max = dat.pla1max < this.splitData[key].labels[j]
              ? this.splitData[key].labels[j] : dat.pla1max;
          } else {
            dat.pla2labels.push(this.splitData[key].labels[j]);
            dat.pla2max = dat.pla2max < this.splitData[key].labels[j]
              ? this.splitData[key].labels[j] : dat.pla2max;
          }
        }
        // console.log(dat)
        columnAtAve[0] = func.round2(func.sumArr(dat.pla1labels) / dat.pla1labels.length);
        columnAtAve[1] = func.round2(func.sumArr(dat.pla2labels) / dat.pla2labels.length);
        if (this.splitData[key].points.length > 0) {
          ret.ave.push(columnAtAve);
        }
      });
      return ret;
    },
    getRallyCnt() {
      const ret = { player1: [], player2: [] };
      Object.keys(this.splitData).forEach((key) => {
        const labelsData = func.getLabelData(
          this.splitData[key].points,
          this.splitData[key].labels,
        );
        if (func.sumArr(labelsData[1]) > 0 || func.sumArr(labelsData[2]) > 0) {
          ret.player1.push(labelsData[1]);
          ret.player2.push(labelsData[2]);
        }
      });
      return ret;
    },
    ...mapGetters([
      'game',
    ]),
  },
};
</script>

<style scoped>
.set{
  font-size: 1.5em;
}

</style>



// WEBPACK FOOTER //
// src/views/DetailData.vue